/* eslint-disable */
import React from 'react';
import { List, ListItem, ListItemText, Radio, Divider, Box } from '@mui/material';
import { isSameDay } from 'date-fns';
import PropTypes from 'prop-types';
import './customDateRange.scss';

const isSameRange = (first, second) => {
  const { startDate: fStart, endDate: fEnd } = first;
  const { startDate: sStart, endDate: sEnd } = second;
  if (fStart && sStart && fEnd && sEnd) {
    return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
  }
  return false;
};

const isCustomRange = (range) => range.label === 'Custom';

const DefinedRanges = (props) => {
  const { ranges, setRange, selectedRange, onCustomSelect } = props;

  const handleRangeSelection = (range) => {
    if (isCustomRange(range)) {
      if (onCustomSelect) {
        onCustomSelect();
      }
    } else {
      setRange(range);
    }
  };

  return (
    <List>
      {ranges.map((range) => (
        <React.Fragment key={range.label}>
          <ListItem onClick={() => handleRangeSelection(range)} style={{ paddingTop: '10px', paddingBottom: '10px' }}>
            <Box
              className="range-box"
              onClick={(e) => {
                e.stopPropagation();
                handleRangeSelection(range);
              }}
            >
              <Radio
                checked={
                  (selectedRange && isSameRange(range, selectedRange)) ||
                  (!selectedRange && range.label === 'Last 2 Months') ||
                  (isCustomRange(range) && selectedRange?.label === 'Custom')
                }
                tabIndex={-1}
                disableRipple
                sx={{
                  '&.Mui-checked': {
                    color: '#6B5CE8',
                  },
                }}
              />
            </Box>
            <ListItemText
              primaryTypographyProps={{
                variant: 'body2',
                className: 'list-item-text',
              }}
              className="range-label"
            >
              {range.label}
            </ListItemText>
          </ListItem>
          <Divider className="divider" />
        </React.Fragment>
      ))}
    </List>
  );
};

DefinedRanges.propTypes = {
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      startDate: PropTypes.instanceOf(Date),
      endDate: PropTypes.instanceOf(Date),
    }),
  ).isRequired,
  setRange: PropTypes.func.isRequired,
  selectedRange: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    label: PropTypes.string,
  }),
  onCustomSelect: PropTypes.func,
};

export default DefinedRanges;
